import { Component } from '@angular/core';
import { NgFor } from '@angular/common';

interface Logo {
  name: string;
  src: string;
  alt: string;
  imgClass: string;
}

@Component({
  selector: 'app-logo-bar',
  standalone: true,
  imports: [NgFor],
  template: `
    <section class="bg-section-bg py-12">
      <div class="max-w-[1480px] mx-auto px-6">
        <p class="text-center text-[#4b5563] text-[16px] leading-[1.65] mb-10">
          Join leading brands transforming their LinkedIn campaigns.
        </p>
        <div
          class="flex items-center justify-center flex-wrap gap-x-14 gap-y-6"
        >
          <div
            *ngFor="let logo of logos"
            class="opacity-80 hover:opacity-100 transition-opacity"
          >
            <img
              [src]="logo.src"
              [alt]="logo.alt"
              [class]="logo.imgClass"
              loading="lazy"
              decoding="async"
              (error)="onImgError($event)"
            />
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [`:host { display: block; }`],
})
export class LogoBarComponent {
  onImgError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.style.display = 'none';
  }

  logos: Logo[] = [
    {
      name: 'CRISIL',
      src: '/logo/crisil.png',
      alt: 'CRISIL logo',
      imgClass: 'h-8 w-auto object-contain',
    },
    {
      name: 'sprinklr',
      src: '/logo/sprinklr.png',
      alt: 'Sprinklr logo',
      imgClass: 'h-7 w-auto object-contain',
    },
    {
      name: 'WNS',
      src: '/logo/wns.png',
      alt: 'WNS logo',
      imgClass: 'h-7 w-auto object-contain',
    },
    {
      name: 'darwinbox',
      src: '/logo/darwinbox.png',
      alt: 'Darwinbox logo',
      imgClass: 'h-6 w-auto object-contain',
    },
    {
      name: 'everstage',
      src: '/logo/everstage.png',
      alt: 'Everstage logo',
      imgClass: 'h-6 w-auto object-contain',
    },
    {
      name: 'SPRINTO',
      src: '/logo/sprinto.png',
      alt: 'Sprinto logo',
      imgClass: 'h-7 w-auto object-contain',
    },
  ];
}
